{
  "search-join-attendee-submit-btn": "DONE",
  "go-to-package-btn": "Purchase Options",
  "done-exit-btn": "Done (Exit Kiosk)",
  "title-select-package": "Select a Package",
  "title-suggest-a-product": "Would you like to add another product to your order?",
  "title-choose-a-product": "Pick a product to add to your order",
  "store-title": "Select the product you'd like to purchase",
  "title-shopping-cart": "Shopping Cart",
  "select-images-notice-message": "Please select images you want to print.",
  "select-images-notice-ok": "OK",
  "confirm-change-img-btn": "OK, Use this image",
  "select-image-title": "OCCO Profile Photo",
  "welcome-title": "Photo Album",
  "welcome-event-list-label": "Event List:",
  "welcome-item-count-label": "Item Count:",
  "select-image-selection-title": "Select ({{count}}) image(s)",
  "select-image-step-label": "Step {{currentStep}} of {{totalSteps}}",
  "select-image-for-product-text": "for \"{{title}}\"",
  "select-image-next-btn": "Next ({{selectedCount}}/{{requiredCount}})",
  "select-image-clear-btn": "Clear",
  "select-image-no-photos-message": "No photos available",
  "select-image-no-uid-message": "Oops, there was an issue locating your account. Please try again.",
  "select-image-unlock-notice-message": "Please select images you want to unlock.",
  "select-image-print-or-unlock-notice-message": "Please select images you want to print or unlock.",
  "select-image-addon-selection-title": "Select images",
  "select-image-addon-done-count-btn": "Done ({{count}})",
  "select-image-no-compatible-image-message": "No compatible image was found",
  "select-image-photo-limit-message": "Please select {{count}} image(s) you want to print.",
  "welcome-gallery-title": "My Album",
  "welcome-select-images-of-yourself-title": "Select all images of yourself",
  "welcome-select-found-images-title": "Select photos you want to add to your gallery",
  "welcome-back-to-gallery-btn": "Back to album",
  "checkout-subtotal-label": "Subtotal:",
  "checkout-taxes-label": "Taxes:",
  "checkout-total-label": "Total:",
  "checkout-btn": "Checkout",
  "checkout-add-on-btn": "+ ADD ON",
  "checkout-add-product-btn": "Add product",
  "checkout-empty-cart-message": "Cart is empty",
  "checkout-promo-code-placeholder": "staff use only",
  "checkout-invalid-promo-code-message": "Invalid or expired promotion code!",
  "checkout-discount-label": "Discount: {{title}}",
  "checkout-receipt-title": "Receipt",
  "checkout-receipt-product-label": "Product",
  "checkout-receipt-unit-price-label": "Unit Price",
  "checkout-receipt-qty-label": "Qty",
  "checkout-receipt-amount-label": "Amount",
  "checkout-digital-package-upsell-message": "Would you like to add a<br>digital package to your<br>shopping cart and gain access<br>to all your digitals?",
  "photo-plus-pass-required-message": "Oops, looks like you do not have a Photo+ Pass yet.<br><br>Get yours now to gain access to high resolution content.",
  "photo-plus-valid-ticket-required-message": "Oops, looks like you don’t have a valid ticket yet for your park visit. Link your ticket to enjoy our Photo+ experience.",
  "photo-plus-visit-availability-message": "Your Photo+ experience is available during your Genting SkyWorlds' visit.",
  "checkout-other-products-upsell-message": "Would you like to add a print to your Digital Package?",
  "checkout-delete-restriction-message": "You must keep at least one package in your shopping cart if you wish to purchase add-ons. If you need to change the package - please first remove all add-ons from your shopping cart.",
  "checkout-digital-package-duplicate-message": "You already have a digital access package in your shopping cart.<br>A new package can not be added until you remove or purchase the current one.",
  "welcome-print-modal-title": "Print",
  "welcome-print-modal-text": "Your photo(s) will be printed and delivered to your event organizer.",
  "cancel-btn": "Cancel",
  "welcome-preview-modal-title": "Preview",
  "close-btn": "Close",
  "ok-btn": "OK",
  "back-btn": "Back",
  "info-title": "Info",
  "apply-btn": "Apply",
  "clear-btn": "Clear",
  "yes-btn": "Yes",
  "no-btn": "No",
  "change-image-btn": "Change Image",
  "done-btn": "Done",
  "skip-btn": "Skip",
  "refresh-btn": "Refresh",
  "exit-btn": "Exit",
  "unsupported-picture-format-message": "Invalid or unsupported picture format",
  "welcome-alert-modal-title": "Modal title",
  "welcome-alert-modal-body-text": "Modal body text goes here.",
  "welcome-alert-save-btn": "Save changes",
  "welcome-passcodes-modal-title": "Generate Pass Codes",
  "welcome-passcodes-events-label": "Select event(s) for which you want to generate passcodes:",
  "welcome-passcodes-email-label": "E-mail address to receive pass codes in XLS format:",
  "welcome-passcodes-count-label": "Number of Pass Codes to generate:",
  "welcome-passcodes-count-help": "A number between 1-200,000",
  "welcome-passcodes-prepaid-label": "Will holders of those cards be considered as pre-paid/VIP?:",
  "welcome-passcodes-expiry-label": "Access to public kiosk must expire (minutes) (0 to disable this option):",
  "welcome-passcodes-url-prefix-label": "Album access URL prefix (e.g. https://domain-name.com):",
  "welcome-passcodes-generate-btn": "Generate",
  "sharing-modal-title": "Share images",
  "sharing-tab-email": "Email",
  "sharing-tab-sms": "SMS",
  "sharing-email-name-placeholder": "Full name",
  "sharing-email-placeholder": "Valid e-mail address",
  "sharing-email-help-text": "Separate multiple email addresses using the semicolon,comma,space and enter keys.",
  "sharing-contact-phone-placeholder": "Phone number",
  "sharing-company-placeholder": "Company/Institution",
  "sharing-sms-name-placeholder": "Full name",
  "sharing-sms-phone-placeholder": "Valid phone number",
  "sharing-privacy-link": "Privacy Policy",
  "sharing-privacy-prefix": "Your privacy is very important to us, please read our",
  "welcome-delete-modal-title": "Delete",
  "welcome-delete-modal-body": "Are you sure you want to delete this picture from your album?",
  "welcome-delete-photo-confirmation-message": "Are you really sure you want to delete this image from your album?",
  "welcome-delete-photo-keep-btn": "Keep this image!",
  "welcome-delete-photo-delete-btn": "Delete this image from my album",
  "welcome-delete-reason-not-mine-btn": "Yes. This is not my picture",
  "welcome-delete-confirm-btn": "Delete",
  "welcome-selfie-modal-title": "Look up my images by face",
  "welcome-selfie-match-found-title": "We think we found you!",
  "welcome-selfie-match-found-confirm-message": "Tap on your images to confirm.",
  "welcome-selfie-capture-btn": "Click here",
  "welcome-delete-reason-dont-want-btn": "Yes. The picture is mine, but don't want it",
  "welcome-print-copy-count-label": "Select print copies count",
  "catalog-select-product-package-title": "Select the product package",
  "freedompay-offline-request-title": "Please enter offline transaction request id",
  "square-reader-access-token-title": "Please enter Square Access Token",
  "square-reader-pairing-code-title": "Please use this code to sign into your new Square reader and click OK when done.",
  "square-reader-still-unpaired-text": "This device is still unpaired, please use the code to sign into your new Square reader.",
  "square-reader-security-note-title": "Please take a note of the following two keys as they will not be saved for security reasons",
  "storicard-invalid-code-text": "Invalid StoriCard code.",
  "header-menu-user-id-link": "UserID:",
  "countdown-time-up-text": "Time's up!",
  "welcome-find-more-images-btn": "Find more images",
  "welcome-select-images-btn": "Select images",
  "welcome-selected-images-next-btn": "That's me on those ({{count}}) images, Next >",
  "welcome-invalid-attendee-id-message": "Invalid attendee ID.",
  "welcome-kiosk-time-expired-message": "Sorry, public kiosk time is expired",
  "welcome-grouping-error-message": "Grouping of accounts created more than 3 days ago is not permitted.",
  "confirm-btn": "Confirm",
  "approved-btn": "Approved",
  "checkout-confirm-purchase-title": "Please Confirm Your Purchase",
  "checkout-confirm-purchase-short-title": "Confirm Purchase",
  "checkout-digital-access-summary": "Access to all of your digital images taken today",
  "checkout-and-text": "and",
  "checkout-print-count-summary": "{{count}} Print(s)",
  "checkout-digitals-copy-message": "Would you like to have a copy of your digitals?<br> In case you misplace your card.",
  "checkout-email-placeholder": "Your email",
  "checkout-email-or-phone-placeholder": "Your email or US phone number",
  "checkout-sms-agreement-label": "I agree to receive notification messages from Storibox at the phone number provided above. I understand I will receive SMS messages containing updates and links to my images. Data and messaging rates may apply. Reply STOP to opt out.",
  "checkout-name-placeholder": "Your name",
  "checkout-cancel-transaction-btn": "Cancel Transaction",
  "checkout-employee-authorization-title": "Employee authorization required",
  "checkout-scan-employee-card-prefix": "Scan your employee card when transaction for",
  "checkout-transaction-complete-suffix": "is complete",
  "checkout-unlock-code-error-message": "Employee authorization code is invalid.",
  "checkout-printing-now-title": "Printing now",
  "checkout-prints-ready-message": "Your prints will be ready in a minute",
  "checkout-digitals-unlocked-message": "Your digital photos are now unlocked",
  "checkout-internal-error-title": "Sorry, Internal error",
  "checkout-transaction-processed-title": "TRANSACTION PROCESSED!",
  "checkout-register-receipt-qr-message": "Please scan QR to register your email for digital receipt and album link!",
  "checkout-shop-more-btn": "Shop More",
  "checkout-print-receipt-btn": "Print Receipt",
  "checkout-paid-by-cash-label": "Paid By Cash",
  "checkout-paid-by-card-label": "Paid By Card",
  "checkout-draft-order-error-message": "Creating draft order failed.",
  "checkout-print-confirmation-message": "If you ordered prints, they will be ready in a minute. You can pick up your merchandise at the retail desk",
  "checkout-shopify-params-incomplete-message": "Shopify Params are not complete",
  "checkout-event-name-required-message": "eventName is not provided.",
  "payment-no-device-connected-message": "No Device is connected.",
  "payment-ask-for-assistance-message": "Please ask for assistance.",
  "payment-square-checkout-creation-failed-message": "Checkout request failed. Please try again later.",
  "payment-square-checkout-status-check-failed-message": "Checkout status check failed. Please try again later.",
  "payment-qr-title": "Pay From Your Phone",
  "payment-qr-help-html": "<b>Quick & Easy:</b><br> Scan the QR code above and follow on screen instructions.",
  "payment-qr-transaction-progress-message": "Transaction is in progress...",
  "payment-qr-failed-message": "QR payment failed. Please check the API key and try again.",
  "payment-failed-message": "Payment failed. Please try again later.",
  "payment-failed-short-message": "Your payment failed.",
  "payment-use-pinpad-message": "Please use the PinPad to complete your transaction ...",
  "payment-terminal-progress-message": "Transaction in progress. <br>To cancel, tap the arrow on terminal.",
  "payment-transaction-canceled-message": "Your transaction has been canceled.",
  "payment-transaction-canceled-close-btn": "Back",
  "payment-transaction-canceled-done-btn": "Home",
  "search-version-label": "kiosk v.{{version}}",
  "search-find-by-qr-btn": "Find by QR",
  "search-find-by-face-btn": "Find by Face",
  "search-scan-another-qr-placeholder": "Scan another QR code",
  "search-scanned-attendee-label": "Scanned: {{attId}}",
  "search-qr-or-photos-not-found-message": "QR Code or photos not found. Please scan again.",
  "scanning-qr-page-title": "Photo Album",
  "photo-viewer-back-btn": "Back to album"
}
